import { Adapter as r } from "../../../../adapter.js";
import { AdyenStoredPaymentMethodModel as p } from "./adyenStoredPaymentMethod.model.js";
class s extends r {
  adapt(e) {
    return new p({
      type: e.type,
      brand: e.brand,
      expiryMonth: e.expiry_month,
      expiryYear: e.expiry_year,
      holderName: e.holder_name,
      id: e.id,
      lastFour: e.last_four,
      name: e.name,
      networkTxReference: e.network_tx_reference,
      supportedRecurringProcessingModels: e.supported_recurring_processing_models ?? [],
      supportedShopperInteractions: e.supported_shopper_interactions ?? [],
      preferred: e.preferred ?? !1
    });
  }
  serialize(e) {
    return {
      type: e.type,
      brand: e.brand,
      expiry_month: e.expiryMonth,
      expiry_year: e.expiryYear,
      holder_name: e.holderName,
      id: e.id,
      last_four: e.lastFour,
      name: e.name,
      network_tx_reference: e.networkTxReference,
      supported_recurring_processing_models: e.supportedRecurringProcessingModels,
      supported_shopper_interactions: e.supportedShopperInteractions,
      preferred: e.preferred
    };
  }
}
export {
  s as AdyenStoredPaymentMethodAdapter
};
//# sourceMappingURL=adyenStoredPaymentMethod.adapter.js.map
